/**
 * SystemManager Component
 * 
 * This component manages the state for the SystemOverview page, allowing users to switch 
 * between different menus and submenus. The active menu is determined by the URL parameter `menu`, 
 * defaulting to 'showDevices' if no parameter is provided.
 */
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Navigationbar from './Navigationbar';
import AddDevices from "./SystemManager/AddDevices";
import DevicesList from "./SystemManager/DevicesList";
import LegendsIconList from './LegendsList';
import HealthPolicyTemplate from "./SystemManager/HealthPolicyTemplate";
import SetHealthTemplateToDevice from "./SystemManager/SetHealthTemplateToDevice";
import globalVariables from "../custom_libraries/globalVariables";


const SystemManager = () => {

  const { menu } = useParams(); //Hooks:  * - `useParams`: Retrieves the `menu` parameter from the URL.  * - `useState`: Manages the component's local state for the active menu and submenu.
  const [activeMenu, setActiveMenu] = useState(menu || 'addDevice'); //State:    * - `activeMenu`: Tracks the currently selected menu. Initialized with the `menu` URL parameter or defaults to 'aiEngineSettings'.
  const [activeSubmenu, setActiveSubmenu] = useState('templates'); // State: `activeSubmenu`: Tracks the currently selected submenu. Initially set to `null`.
  const [userType, setUserType] = useState(''); //state to control visibility of submenus nased on user type

  
  useEffect(() => {
    // Retrieve the user type from localStorage
    const storedUserType = localStorage.getItem(globalVariables.USER_TYPE);
    setUserType(storedUserType);
  }, [])

  const handleMenuClick = (menu) => {   //Updates the `activeMenu` state to the selected menu.
    setActiveMenu(menu);    
  };

  const handleSubmenuClick = (submenu) => { //Updates the `activeSubmenu` state to the selected submenu.
    setActiveSubmenu(submenu);
  };

  return (
    <div className="system-overview-page">
        {/* <Navigationbar /> */}
      <div className="sidebar">
        <ul>
          <li style={{borderBlock:'1px solid white'}}>
            Device Manager
          </li><br/>
          <li className={activeMenu === 'addDevice' ? 'active' : ''} onClick={() => handleMenuClick('addDevice')}>
            <Link to="/system-manager/addDevice">Add New Device</Link>
          </li>
          <li className={activeMenu === 'listDevices' ? 'active' : ''} onClick={() => handleMenuClick('listDevices')}>
            <Link to="/system-manager/listDevices">Devices</Link>
          </li>
          {/* <li className={activeMenu === 'advancedConfig' ? 'active' : ''} onClick={() => handleMenuClick('advancedConfig')}>
            <Link to="/system-manager/advancedConfig">Advanced Configurations</Link>
          </li> */}
          <li className={activeMenu === 'healthSettings' ? 'active' : ''} onClick={() => handleMenuClick('healthSettings')}>
            <Link to="/system-manager/healthSettings">Health Settings</Link>
          </li>
          {activeMenu === "healthSettings" && (
            <ul className="submenu">
              <li
                className={activeSubmenu === "templates" ? "active" : ""}
                onClick={() => handleSubmenuClick("templates")}
              >
                <Link to="/system-manager/healthtemplates">- create Templates</Link>
              </li>
              <li
                className={activeSubmenu === "setTemplate" ? "active" : ""}
                onClick={() => handleSubmenuClick("setTemplate")}
              >
                <Link to="/system-manager/setTemplate">- Set Template </Link>
              </li>
            </ul>
          )}
        </ul>
      </div>
      {activeMenu === 'listDevices' &&(
        <div className="system-overview-content-container">
          {/* <LegendsIconList /> */}
          <div className="system-overview-page-content">
          <DevicesList />
          </div>
        </div>
      )}
      <div className="system-overview-page-content">
      
        {activeMenu === 'addDevice' && !activeSubmenu && <AddDevices />}
        {activeMenu === 'addDevice' && <AddDevices />}
        {activeMenu === "healthSettings" && !activeSubmenu && <HealthPolicyTemplate />}
        {activeMenu === "healthSettings" && activeSubmenu === "templates" && <HealthPolicyTemplate />}
        {activeMenu === "healthSettings" && activeSubmenu === "setTemplate" && <SetHealthTemplateToDevice />}
      </div>
    </div>
  );
};

export default SystemManager;
